/** Data related to a user */
export interface User {
  /** @return The actual value for the SysId or an empty string */
  plumeSysId?: string;
  /** @return The actual value for the IDRH or an empty string */
  idrh?: string;
  /** @return The authentication token for the user or an empty string, absent for authType "oidc" */
  token?: string;
  /**
   * Populated only for authType "oidc": a live, in-memory verdict of the backend session
   * verification. Never persisted.
   */
  authenticated?: boolean;
  /**
   * Populated only for authType "oidc": the opaque session id currently verified. It carries no
   * user information and is sent as X-Arole-Auth-Session-Id on outgoing-message calls.
   */
  sessionId?: string;
}

/** Data related to a user persisted on a storage */
export class PersistedUser {
  idrh: string = "";
  IDRH: string = "";
  "user-jwt": string = "";
  sys_id: string = "";
  /** Opaque loader-issued OIDC session id, the only durable OIDC artifact */
  sessionId: string = "";
}

/** Data related to the rights of the current user */
export interface UserRights {
  /** @return Whether the user can write a message */
  canWrite: string;
}
